
import { useTranslation } from 'react-i18next';
export default function CompanyProfileSection() {

  const { t } = useTranslation();

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4"> {t('about.companyProfile')}</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-500 to-yellow-500 mx-auto"></div>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">{t('about.about1')}</h3>
              <div className="space-y-6 text-gray-700 leading-relaxed">
                <p>{t('about.about2')}</p>
                <p>{t('about.about3')}</p>
                <p>{t('about.about4')}</p>
                <p>{t('about.about5')}</p>
              </div>
            </div>
            
            <div className="relative">
              <img 
                src="/img/3ba9464250a5ce4f2da7bd26048e0d27.jpg"
                alt="GOLD Label Global Trading Environment"
                className="w-full h-80 object-cover rounded-lg shadow-xl"
              />
              <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full flex items-center justify-center shadow-lg">
                <i className="ri-award-fill text-white text-2xl"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
